import { UrlSerializer, UrlTree, DefaultUrlSerializer } from '@angular/router';

export class CustomUrlSerializer implements UrlSerializer {
    parse(url: string): UrlTree {
        let dus = new DefaultUrlSerializer();

        // Only apply encoding when the URL has the customer name (when doing an opt action)
        if (url.substring(0, 4).includes('opt')) {
            // Divide the URL into segments
            let segments = this.getSegments(url);
            let beforeName = segments[0];
            let name = segments[1];
            let afterName = segments[2];
            
            // First decode the name to convert '%20' to ' ', which prevents the '%' in '%20' from being encoded. 
            // The browswer automatically changes any ' ' in the URL to '%20'
            // Need try/catch because sometimes name has '%', which breaks the decode, so we must encode first
            try {
                name = decodeURIComponent(name);
            }
            catch(e) {
                name = decodeURIComponent(encodeURIComponent(name));
            }

            // Double encode the name to allow special characters
            // Need to double encode because the browser automatically decodes '%5C' (\) and '%2F' (/)
            // But it does not decode '%255C' and '%252F' (%25 = %)
            return dus.parse(beforeName + encodeURIComponent(encodeURIComponent(name)) + afterName)
        }
        
        return dus.parse(url)
        
    }

    serialize(tree: UrlTree): any {
        let dus = new DefaultUrlSerializer()
        let path = dus.serialize(tree);

        // Only apply decoding when the URL has the customer name
        if (path.substring(0, 4).includes('opt')) {
            // Divide the path into segments
            let segments = this.getSegments(path);
            let beforeName = segments[0];
            let name = segments[1];
            let afterName = segments[2];
            
            // Double decode the name to undo the double encode that was performed in parse
            // No decodes allow travel to URL, but does not allow the user to refreshes
            // One decode allows travel and refreshes, but URL is not as legible (special characters are still encoded)
            // Two decodes allows travel and refreshes, and URL is more as legible (special characters in regular text)
            return beforeName + decodeURIComponent(decodeURIComponent(name)) + afterName
        }

        return path
    }

    getSegments(path: string): string[] {
        // Search from beginning for the start of the name incase of a '/' in the name
        let afterSlashFourIndex = 20;
        let slashFiveIndex = path.indexOf('/', afterSlashFourIndex);

        // Search for the end of the name using the last '/' in the path
        let slashLastIndex = path.lastIndexOf('/');
        
        //Divide the path into three segments (before the name, the name, after the name)
        let beforeName = path.substring(0, slashFiveIndex + 1);
        let name = path.substring(slashFiveIndex + 1, slashLastIndex);
        let afterName = path.substring(slashLastIndex, path.length);

        return [beforeName, name, afterName]
    }
}